import React from 'react';
import IntroOutroContext from '../IntroOutroContext';

export default function IntroOutroProvider(props) {
  const { value, children } = props;
  return <IntroOutroContext.Provider value={value}>{children}</IntroOutroContext.Provider>;
}
